import { LineElement } from '@thive/canvas';
import { Vector3 } from 'three';

import { calculateZoomInRange } from '@/modules/canvas/helpers';
import { elementFactory } from '@/modules/canvas/factories';
import { Z_INDEX_MAP } from '@/modules/canvas/constants/elements';
import { FDDM_TAG, INTERACTIVITY_OFF } from '@/modules/floorplanDesign/constants';

import {
  REFERENCE_LINE_ELEMENT_ID,
  REFERENCE_SCALE_ELEMENT_STROKE_WIDTH,
  REFERENCE_SCALING_ELEMENTS_COLOR_HEX,
} from './constants';

export const calcScalingElementsSize = (zoom: number) => {
  const crossLineLength = calculateZoomInRange(zoom, 0, 1000, 25, 25 * 10);
  return {
    crossLineLength,
  };
};

export const buildScaleCrossElements = (
  id: string,
  zoom: number,
  centerPosition: { x: number; y: number },
): [LineElement, LineElement] => {
  const sizes = calcScalingElementsSize(zoom);
  const halfLineLength = sizes.crossLineLength / 2;
  const orthogonalPointOffset = halfLineLength / Math.sqrt(2);

  // line \
  const lineA: LineElement = elementFactory.buildLineElement({
    name: `${id}-line-A`,
    id: `${id}-line-A`,
    pointA: new Vector3(
      centerPosition.x - orthogonalPointOffset,
      centerPosition.y + orthogonalPointOffset,
      Z_INDEX_MAP[FDDM_TAG.REFERENCE_SCALING_POINT_CROSS_LINE_A],
    ),
    pointB: new Vector3(
      centerPosition.x + orthogonalPointOffset,
      centerPosition.y - orthogonalPointOffset,
      Z_INDEX_MAP[FDDM_TAG.REFERENCE_SCALING_POINT_CROSS_LINE_A],
    ),
    stroke: {
      color: REFERENCE_SCALING_ELEMENTS_COLOR_HEX,
      width: REFERENCE_SCALE_ELEMENT_STROKE_WIDTH,
    },
    interactivity: INTERACTIVITY_OFF,
    tags: [FDDM_TAG.REFERENCE_SCALING_POINT_CROSS_LINE_A],
  });

  // line /
  const lineB: LineElement = elementFactory.buildLineElement({
    id: `${id}-line-B`,
    name: `${id}-line-B`,
    pointA: new Vector3(
      centerPosition.x - orthogonalPointOffset,
      centerPosition.y - orthogonalPointOffset,
      Z_INDEX_MAP[FDDM_TAG.REFERENCE_SCALING_POINT_CROSS_LINE_B],
    ),
    pointB: new Vector3(
      centerPosition.x + orthogonalPointOffset,
      centerPosition.y + orthogonalPointOffset,
      Z_INDEX_MAP[FDDM_TAG.REFERENCE_SCALING_POINT_CROSS_LINE_B],
    ),
    stroke: {
      color: REFERENCE_SCALING_ELEMENTS_COLOR_HEX,
      width: REFERENCE_SCALE_ELEMENT_STROKE_WIDTH,
    },
    interactivity: INTERACTIVITY_OFF,
    tags: [FDDM_TAG.REFERENCE_SCALING_POINT_CROSS_LINE_B],
  });

  return [lineA, lineB];
};

export const buildScaleLineElement = (
  p1: { x: number; y: number },
  p2: { x: number; y: number },
): LineElement => {
  const line: LineElement = elementFactory.buildLineElement({
    id: REFERENCE_LINE_ELEMENT_ID,
    name: 'reference-scale-line',
    pointA: new Vector3(p1.x, p1.y, Z_INDEX_MAP[FDDM_TAG.REFERENCE_SCALING_LINE]),
    pointB: new Vector3(p2.x, p2.y, Z_INDEX_MAP[FDDM_TAG.REFERENCE_SCALING_LINE]),
    stroke: {
      color: REFERENCE_SCALING_ELEMENTS_COLOR_HEX,
      width: REFERENCE_SCALE_ELEMENT_STROKE_WIDTH,
    },
    interactivity: INTERACTIVITY_OFF,
    tags: [FDDM_TAG.REFERENCE_SCALING_LINE],
  });

  return line;
};
